import styled from 'styled-components';

const HeroSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 84px);
  padding: 2rem 0;
`;

export default HeroSection;
